<template>
  <div class="mt-2">
    <div v-if="!disabled" class="inline-block">
      Your feedback has been submitted. If you'd like, provide any more detail
      here (optional):
    </div>
    <div>
      <LegacyTTextarea
        v-if="!disabled || !!customFeedbackReason"
        v-model="customFeedbackReason"
        :disabled="disabled"
        name="custom-feedback-input"
        :rows="5"
        @keydown.enter="() => !disabled && submitCustomFeedback()"
      />
    </div>
    <div v-if="!disabled" class="flex flex-row justify-end mt-2">
      <TMSecondaryButton label="Send" @click="() => submitCustomFeedback()" />
    </div>
  </div>
</template>

<script lang="ts">
import TMSecondaryButton from '@nashville/button/TMSecondaryButton.vue'
import { defineComponent } from 'vue'
import LegacyTTextarea from '@/legacy/nashville/input/LegacyTTextarea.vue'
import { setup } from './controller'
import { CUSTOM_FEEDBACK_PROPS } from './types'

export default defineComponent({
  components: { TMSecondaryButton, LegacyTTextarea },
  props: CUSTOM_FEEDBACK_PROPS,
  setup,
})
</script>
